import { jsx as _jsx } from "react/jsx-runtime";
import { ELEMENT_TYPES } from '../../helpers/ElementTypes';
import { PanelStickerContainer } from './styles';
const PanelSticker = ({ children }) => {
    return _jsx(PanelStickerContainer, { children: children });
};
PanelSticker.PANEL_ELEMENT = ELEMENT_TYPES.STICKER;
export { PanelSticker };
